"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegTweaksSettingsT = exports.LegTweaksSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class LegTweaksSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsLegTweaksSettings(bb, obj) {
        return (obj || new LegTweaksSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsLegTweaksSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new LegTweaksSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    correctionStrength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    static startLegTweaksSettings(builder) {
        builder.startObject(1);
    }
    static addCorrectionStrength(builder, correctionStrength) {
        builder.addFieldFloat32(0, correctionStrength, 0);
    }
    static endLegTweaksSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createLegTweaksSettings(builder, correctionStrength) {
        LegTweaksSettings.startLegTweaksSettings(builder);
        if (correctionStrength !== null)
            LegTweaksSettings.addCorrectionStrength(builder, correctionStrength);
        return LegTweaksSettings.endLegTweaksSettings(builder);
    }
    unpack() {
        return new LegTweaksSettingsT(this.correctionStrength());
    }
    unpackTo(_o) {
        _o.correctionStrength = this.correctionStrength();
    }
}
exports.LegTweaksSettings = LegTweaksSettings;
class LegTweaksSettingsT {
    constructor(correctionStrength = null) {
        this.correctionStrength = correctionStrength;
    }
    pack(builder) {
        return LegTweaksSettings.createLegTweaksSettings(builder, this.correctionStrength);
    }
}
exports.LegTweaksSettingsT = LegTweaksSettingsT;
